"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatUrlHttps = formatUrlHttps;
exports.constructUrl = constructUrl;
const regex_1 = require("./regex");
/**
 * This function takes a valid url and ensures it begins with https://
 * If the url is not valid, it will be returned without changes
 */
function formatUrlHttps(url) {
    if (!regex_1.URL_REGEX.test(url))
        return url;
    const http = RegExp('http://');
    const https = RegExp('https://');
    if (http.test(url))
        return url.replace(http, 'https://');
    else if (https.test(url))
        return url;
    else
        return 'https://' + url;
}
/**
 *
 * @param {string} url Base URL
 * @param {string[]} pathname Pathname segments
 * @param {Record<string, string>} query Query parameters
 * @returns {string} Constructed URL
 */
function constructUrl(url, pathname, query, { trailingSlash } = { trailingSlash: true }) {
    const constructedUrl = new URL(url);
    // Normalize and append pathname segments
    if (pathname && pathname.length > 0) {
        constructedUrl.pathname = constructedUrl.pathname
            .replace(/\/+$/, '') // Remove trailing slashes from the base pathname
            .concat('/', Array.isArray(pathname) ? pathname.join('/') : pathname, '/')
            .replace(/\/{2,}/g, '/'); // Normalize double slashes
    }
    // Handle query parameters if provided
    if (query && Object.keys(query).length > 0) {
        constructedUrl.search = new URLSearchParams(query).toString();
    }
    return constructedUrl.href.replace(!trailingSlash ? /\/(?=$|\?)/ : /$/, ''); // Remove trailing slash if not required
}
